import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import HelpCenterSettingsWidgetConfigurationCustomizeAppQuery from '@atlassian/jira-relay/src/__generated__/HelpCenterSettingsWidgetConfigurationCustomizeAppQuery.graphql';

export const customizeEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-widget-configuration-customize-app" */ './src/ui/HelpCenterSettingsWidgetConfigurationCustomizeApp.tsx'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				page: {
					parameters: HelpCenterSettingsWidgetConfigurationCustomizeAppQuery,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
